import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { OrganizationService } from '../../services/organization/organization.service';

export const organizationGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const organizationService = inject(OrganizationService);
  const router = inject(Router);

  // Might want a more detailed check in the future, right now we just check if the user is in any organization
  return userService.getCurrentUser().pipe(
    switchMap((user) =>
      user.memberships.length > 0
        ? organizationService.getCurrentOrganization().pipe(
            map(() => true),
            catchError(() => of(false)),
          )
        : of(new RedirectCommand(router.parseUrl('/organizations/create'))),
    ),
  );
};
